import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {AppService} from '../app.service';

@Component({
    selector: 'app-rozvrh',
    templateUrl: './rozvrh.component.html',
    styleUrls: ['./rozvrh.component.css'],
    standalone: false
})
export class RozvrhComponent implements OnInit {

  constructor(@Inject(LOCALE_ID) private locale: string) { }

  ngOnInit(): void {
  }

  openRozvrh() {
    window.location.href = '/ais/apps/rozvrh/' + this.locale + '/';
  }
}
